import { useMemo } from 'react';
import { today } from 'src/lib/date';

const useCalendar = (initialDate: Date = today(), options?: { startOfWeek?: number }) => {
  const { startOfWeek = 1 } = options || {};
  const weeks = useMemo(() => {
    const first = new Date(initialDate);
    first.setDate(1);
    const dow = first.getDay();
    if (first.getDay() !== startOfWeek) {
      first.setDate(first.getDate() - dow + startOfWeek);
      if (dow < startOfWeek) {
        first.setDate(first.getDate() - 7);
      }
    }
    const res = [];
    let current = new Date(first);
    do {
      const week = [];
      for (let i = 0; i < 7; i++) {
        week.push(new Date(current));
        current.setDate(current.getDate() + 1);
      }
      res.push(week);
    } while (current.getMonth() === initialDate.getMonth());
    return res;
  }, [initialDate, startOfWeek]);

  const firstDay = weeks[0][0];
  const lastDay = weeks[weeks.length - 1][6];

  return { weeks, firstDay, lastDay };
};

export default useCalendar;
